import {createI18n} from 'vue-i18n'

import enDefault from '@/i18n/en/default.ts'
import enGDPR from '@/i18n/en/gdpr.ts'

import frDefault from '@/i18n/fr/default.ts'
import frGDPR from '@/i18n/fr/gdpr.ts'

export default createI18n({
    legacy: false,
    locale: 'fr',
    fallbackLocale: 'fr',
    messages: {
        en: {
            ...enDefault,
            gdpr: enGDPR
        },
        fr: {
            ...frDefault,
            gdpr: frGDPR
        }
    }
})